import '@/modules/card';
import '@/modules/pagination';
import ProductForm from '@/modules/product-form'
import { FacetFilters, FacetFiltersForm, PriceRange, FacetRemove } from '@/modules/filter';

if (document.getElementsByTagName('product-form')) {
    if(!customElements.get('product-form')) {
        customElements.define('product-form', ProductForm);
    }
}

if (document.getElementsByTagName('facet-filters-form')) {
    customElements.define('facet-filters', FacetFilters);
    customElements.define('facet-filters-form', FacetFiltersForm);
    customElements.define('price-range', PriceRange);
    customElements.define('facet-remove', FacetRemove);
}
